import validate from 'validate.js';

const validateCsvForm = (values = {}) => {
  const { from, to } = values;
  return {
    from: validate.single(from,
      {
        presence: { allowEmpty: false }
      }),
    to: validate.single(to,
      {
        presence: { allowEmpty: false }
      })
  };
};

export default validateCsvForm;
